/* LeParfin : conseiller virtuel (sections/lp-chat.liquid, snippets/lp-chat.liquid, assets/lp-chat.css).
   - Bouton rond en bas à droite ; le panneau est construit au premier clic.
   - Plein écran sur mobile (moins de 768 px) : panneau calé sur la zone visible (visualViewport, suivi image par image
     tant que le champ a le focus), champ collé au clavier, page figée derrière (body en position fixed, défilement
     rendu à l'identique à la fermeture), éléments collants du site masqués (classe lpc-lock sur html).
   - Conversation gardée dans l'onglet seulement (sessionStorage) ; rien d'autre n'est stocké.
   - « Écrire à l'équipe » ouvre le formulaire de contact du thème (form.lp-cf-form), prérempli avec la conversation
     et le bon sujet ; la conversation passe par sessionStorage, jamais par l'adresse de la page.
   - Liens cliquables seulement vers les pages autorisées du site ; tout le reste est affiché en texte. */
(function () {
  'use strict';

  var STORE = 'lpchat:v1';
  var PREFILL = 'lpchat:prefill';
  var MAX_TURNS = 12;
  var MAX_LEN = 600;
  var TIMEOUT = 25000;
  var PREFILL_TTL = 30 * 60 * 1000;
  var ALLOWED = [
    '/collections/all', '/collections/all?view=quiz', '/collections/all?view=selection',
    '/products/velora-vanille-gourmande', '/products/aelon-bleu-d-aube', '/products/rubia-petales-fruites',
    '/products/solea-soleil-de-monoi', '/products/melia-sillage-d-ambre', '/products/sevra-voile-de-musc',
    '/products/pack-de-noel', '/products/pochette-leparfin',
    '/pages/faq?view=faq', '/pages/faq?view=faq#commande', '/pages/faq?view=faq#livraison', '/pages/faq?view=faq#composition',
    '/pages/notre-histoire?view=histoire', '/pages/avis?view=avis'
  ];
  /* Sujet du formulaire selon le thème de la conversation (partie 12 de la base). */
  var SUBJECTS = {
    conseil: 'Choisir un parfum',
    composition: 'Composition et allergies',
    commande: 'Ma commande',
    livraison: 'Livraison et retours',
    retour: 'Livraison et retours',
    revendeur: 'Devenir revendeur'
  };
  var OTHER = 'Autre question';

  var ss = {
    get: function (k) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* stockage indisponible */ } },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) { /* rien */ } }
  };
  function publish(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data || {}); } catch (e) { /* rien */ }
  }
  function mk(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
    return n;
  }
  function svg(paths) {
    var ns = 'http://www.w3.org/2000/svg';
    var s = document.createElementNS(ns, 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    paths.forEach(function (d) { var p = document.createElementNS(ns, 'path'); p.setAttribute('d', d); s.appendChild(p); });
    return s;
  }
  var reduced = function () { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); };
  var small = function () { return !!(window.matchMedia && matchMedia('(max-width: 767px)').matches); };

  /* ---------- Texte des réponses : liens autorisés seulement ---------- */
  function plain(t) {
    return String(t || '').replace(/\[([^\]]+)\]\(([^)]+)\)/g, '$1').replace(/[  ]/g, ' ');
  }
  function richText(node, text) {
    var re = /\[([^\]\n]{1,120})\]\((\/[^)\s]{1,200})\)|(hello@leparfin\.com)/g;
    var last = 0;
    var m;
    var linked = false;
    while ((m = re.exec(text))) {
      if (m.index > last) node.appendChild(document.createTextNode(text.slice(last, m.index)));
      if (m[3]) {
        var mail = mk('a', 'lpc-a', { href: 'mailto:hello@leparfin.com' });
        mail.textContent = m[3];
        node.appendChild(mail);
      } else if (!linked && ALLOWED.indexOf(m[2]) !== -1) {
        var a = mk('a', 'lpc-a', { href: m[2] });
        a.textContent = m[1];
        a.addEventListener('click', function () { publish('lp_chat_link', {}); });
        node.appendChild(a);
        linked = true;
      } else {
        node.appendChild(document.createTextNode(m[1]));
      }
      last = re.lastIndex;
    }
    if (last < text.length) node.appendChild(document.createTextNode(text.slice(last)));
  }

  /* ---------- Formulaire de contact prérempli ---------- */
  function findForm(scope) {
    var f = (scope || document).querySelector('form.lp-cf-form');
    if (f) return f;
    var all = (scope || document).querySelectorAll('form');
    for (var i = 0; i < all.length; i += 1) if (all[i].querySelector('textarea[name="contact[body]"]')) return all[i];
    return null;
  }
  function fillForm(form, pre) {
    if (!form || !pre) return false;
    if (form.querySelector('.bs-ok, .lp-cf-ok')) return false; // message déjà envoyé
    var ta = form.querySelector('textarea[name="contact[body]"]');
    if (ta) {
      ta.value = ta.value.trim() ? ta.value.replace(/\s+$/, '') + '\n' + pre.body : pre.body;
      ta.dispatchEvent(new Event('input', { bubbles: true }));
    }
    var sels = form.querySelectorAll('select');
    for (var i = 0; i < sels.length; i += 1) {
      var sel = sels[i];
      for (var j = 0; j < sel.options.length; j += 1) {
        if (sel.options[j].value.trim().toLowerCase() === String(pre.subject).toLowerCase()) {
          if (!sel.value) { sel.value = sel.options[j].value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
          j = sel.options.length;
          i = sels.length;
        }
      }
    }
    if (!form.querySelector('input[name="contact[Source]"]')) {
      var h = mk('input', '', { type: 'hidden', name: 'contact[Source]', value: 'Assistant virtuel' });
      form.appendChild(h);
    }
    if (ta) {
      try { ta.focus({ preventScroll: true }); ta.setSelectionRange(0, 0); ta.scrollTop = 0; } catch (e) { /* rien */ }
      ta.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
    }
    return true;
  }
  function applyPendingPrefill() {
    var pre = ss.get(PREFILL);
    if (!pre) return;
    if (!pre.ts || Date.now() - pre.ts > PREFILL_TTL) { ss.del(PREFILL); return; }
    var form = findForm(document);
    if (!form) return;
    fillForm(form, pre);
    ss.del(PREFILL);
  }

  /* ---------- Widget ---------- */
  function init(host) {
    if (host.__lpc) return;
    host.__lpc = true;
    var cfg;
    try { cfg = JSON.parse(host.querySelector('[data-lpc-config]').textContent); } catch (e) { return; }
    if (!cfg.endpoint) return;
    var L = cfg.labels || {};
    var launch = host.querySelector('[data-lpc-open]');
    var dot = host.querySelector('[data-lpc-dot]');
    var panelId = 'lpc-panel-' + cfg.id;

    var state = ss.get(STORE);
    if (!state || state.v !== 1 || !Array.isArray(state.msgs)) state = { v: 1, msgs: [] };
    var save = function () { if (!cfg.design) ss.set(STORE, state); };
    var userCount = function () { return state.msgs.filter(function (m) { return m.r === 'u'; }).length; };
    var hasConv = function () { return state.msgs.some(function (m) { return m.r === 'u'; }); };

    var panel = null;
    var log = null;
    var form = null;
    var ta = null;
    var sendBtn = null;
    var count = null;
    var typing = null;
    var sugg = null;
    var busy = false;
    var isOpen = false;
    var opener = null;

    function updateDot() { if (dot) dot.hidden = !hasConv() || isOpen; }

    /* Au-dessus de la barre d'achat collante (fiche produit), du plateau de sélection et du badge
       anti-robot que Shopify pose en bas à droite des pages avec formulaire (contact, aide). */
    function lift() {
      var h = 0;
      var sticky = document.querySelector('.sticky.on');
      if (sticky) h = Math.max(h, sticky.getBoundingClientRect().height);
      var tray = document.querySelector('.tray');
      if (tray && document.body.classList.contains('has-tray')) {
        var r = tray.getBoundingClientRect();
        if (r.height && r.top < innerHeight) h = Math.max(h, innerHeight - r.top);
      }
      if (!host.classList.contains('lpc-left')) {
        var cap = document.getElementById('shop-hcaptcha-badge-container') || document.querySelector('.grecaptcha-badge');
        if (cap) {
          var c = cap.getBoundingClientRect();
          var off = parseFloat(getComputedStyle(host).getPropertyValue('--lpc-off')) || 16;
          if (c.height && c.top < innerHeight && c.right > innerWidth - 96) h = Math.max(h, innerHeight - c.top + 8 - off);
        }
      }
      host.style.setProperty('--lpc-lift', h ? Math.round(h + 2) + 'px' : '0px');
    }
    var liftQueued = false;
    function queueLift() {
      if (liftQueued) return;
      liftQueued = true;
      requestAnimationFrame(function () { liftQueued = false; lift(); });
    }
    addEventListener('scroll', queueLift, { passive: true });
    addEventListener('resize', queueLift);
    try { new MutationObserver(queueLift).observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true }); } catch (e) { /* rien */ }
    lift();
    setTimeout(queueLift, 2500); /* badge anti-robot ajouté après le chargement */

    /* ---------- Construction du panneau (premier clic) ---------- */
    function build() {
      panel = mk('section', 'lpc-p', { id: panelId, role: 'dialog', 'aria-modal': 'false', 'aria-labelledby': panelId + '-t', hidden: '' });

      var head = mk('header', 'lpc-h');
      var av = mk('span', 'lpc-av', { 'aria-hidden': 'true' });
      av.textContent = 'LP';
      var ht = mk('div', 'lpc-ht');
      var h2 = mk('h2', 'lpc-t', { id: panelId + '-t', tabindex: '-1' });
      h2.textContent = cfg.title || '';
      var sub = mk('p', 'lpc-s');
      sub.textContent = cfg.subtitle || '';
      ht.appendChild(h2);
      ht.appendChild(sub);
      var reset = mk('button', 'lpc-ib', { type: 'button', 'aria-label': L.reset || '', title: L.reset || '' });
      reset.appendChild(svg(['M4 12a8 8 0 1 0 2.4-5.7', 'M4 4v4.5h4.5']));
      var close = mk('button', 'lpc-ib', { type: 'button', 'aria-label': L.close || '', title: L.close || '' });
      close.appendChild(svg(['M6 6l12 12M18 6 6 18']));
      head.appendChild(av);
      head.appendChild(ht);
      head.appendChild(reset);
      head.appendChild(close);

      log = mk('div', 'lpc-log', { role: 'log', 'aria-live': 'polite', 'aria-relevant': 'additions', tabindex: '0', 'aria-label': cfg.title || '' });

      form = mk('form', 'lpc-f', { novalidate: '' });
      var lab = mk('label', 'sr', { for: panelId + '-in' });
      lab.textContent = L.input || '';
      ta = mk('textarea', 'lpc-in', { id: panelId + '-in', rows: '1', maxlength: String(MAX_LEN), placeholder: cfg.placeholder || '', enterkeyhint: 'send', autocomplete: 'off', 'aria-describedby': panelId + '-c' });
      sendBtn = mk('button', 'lpc-send', { type: 'submit', 'aria-label': L.send || '' });
      sendBtn.appendChild(svg(['M5 12h13', 'M13 6l6 6-6 6']));
      count = mk('p', 'lpc-cnt', { id: panelId + '-c', 'aria-live': 'polite' });
      form.appendChild(lab);
      form.appendChild(ta);
      form.appendChild(sendBtn);

      var foot = mk('div', 'lpc-ft');
      var legal = mk('p', 'lpc-legal');
      legal.textContent = cfg.disclaimer || '';
      var team = mk('button', 'lpc-team', { type: 'button' });
      team.appendChild(svg(['M4 6.5h16v11H4z', 'M4.5 7l7.5 6 7.5-6']));
      team.appendChild(document.createTextNode(cfg.team || ''));
      foot.appendChild(legal);
      foot.appendChild(team);

      panel.appendChild(head);
      panel.appendChild(log);
      panel.appendChild(count);
      panel.appendChild(form);
      panel.appendChild(foot);
      host.appendChild(panel);
      launch.setAttribute('aria-controls', panelId); /* posé seulement quand le panneau existe */

      close.addEventListener('click', function () { closePanel(true); });
      reset.addEventListener('click', function () {
        state = { v: 1, msgs: [] };
        save();
        renderAll();
        updateDot();
        focusInput();
      });
      team.addEventListener('click', function () { toTeam('pied'); });
      form.addEventListener('submit', function (e) { e.preventDefault(); send(ta.value); });
      ta.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); send(ta.value); }
      });
      ta.addEventListener('input', function () { grow(); counter(); });
      ta.addEventListener('focus', function () { watch(900); });
      ta.addEventListener('blur', function () { watch(900); });
      /* Plein écran : seul le fil des messages (ou le champ) défile sous le doigt, le reste ne bouge pas. */
      panel.addEventListener('touchmove', function (e) {
        if (!pageLock) return;
        var t = e.target;
        if (log.contains(t) && log.scrollHeight > log.clientHeight + 1) return;
        if (t === ta && ta.scrollHeight > ta.clientHeight + 1) return;
        if (e.cancelable) e.preventDefault();
      }, { passive: false });
      panel.addEventListener('keydown', onKey);
      renderAll();
    }

    function grow() {
      ta.style.height = 'auto';
      ta.style.height = Math.min(ta.scrollHeight, 132) + 'px';
    }
    function counter() {
      var n = ta.value.length;
      count.textContent = n > MAX_LEN - 100 ? n + ' / ' + MAX_LEN + ' ' : '';
      count.setAttribute('aria-label', n > MAX_LEN - 100 ? n + ' ' + (L.count || '') : '');
    }

    /* ---------- Affichage des messages ---------- */
    function bubble(m) {
      var row = mk('div', 'lpc-m lpc-m-' + (m.r === 'u' ? 'u' : m.r === 'e' ? 'e' : 'a'));
      var who = mk('span', 'sr');
      who.textContent = (m.r === 'u' ? L.you : L.bot) + ' : ';
      var b = mk('div', 'lpc-b');
      b.appendChild(who);
      if (m.r === 'u') b.appendChild(document.createTextNode(m.t));
      else richText(b, m.t);
      row.appendChild(b);
      return row;
    }
    function card() {
      var c = mk('div', 'lpc-card');
      var p = mk('p', 'lpc-card-t');
      p.textContent = cfg.handoffText || '';
      var btn = mk('button', 'lpc-cta', { type: 'button' });
      btn.appendChild(svg(['M4 6.5h16v11H4z', 'M4.5 7l7.5 6 7.5-6']));
      btn.appendChild(document.createTextNode(cfg.team || ''));
      btn.addEventListener('click', function () { toTeam('carte'); });
      c.appendChild(p);
      c.appendChild(btn);
      return c;
    }
    function suggestions() {
      var list = (cfg.suggestions || []).filter(Boolean);
      if (!list.length) return null;
      var wrap = mk('div', 'lpc-sug', { role: 'group', 'aria-label': L.suggestions || '' });
      list.forEach(function (q) {
        var b = mk('button', 'lpc-chip', { type: 'button' });
        b.textContent = q;
        b.addEventListener('click', function () { send(q); });
        wrap.appendChild(b);
      });
      return wrap;
    }
    function renderAll() {
      log.textContent = '';
      log.appendChild(bubble({ r: 'a', t: cfg.welcome || '' }));
      sugg = hasConv() ? null : suggestions();
      if (sugg) log.appendChild(sugg);
      var lastHand = -1;
      state.msgs.forEach(function (m, i) { if (m.r !== 'u' && m.h) lastHand = i; });
      state.msgs.forEach(function (m, i) {
        log.appendChild(bubble(m));
        if (i === lastHand) log.appendChild(card());
      });
      lockIfDone();
      scrollEnd();
    }
    function scrollEnd() { if (log) log.scrollTop = log.scrollHeight; }
    function lockIfDone() {
      var done = userCount() >= MAX_TURNS;
      ta.disabled = done || busy;
      sendBtn.disabled = done || busy;
      if (done && !log.querySelector('.lpc-done')) {
        var p = mk('p', 'lpc-done');
        p.textContent = cfg.turnsText || '';
        log.appendChild(p);
        log.appendChild(card());
      }
    }
    function showTyping() {
      typing = mk('div', 'lpc-m lpc-m-a lpc-typing');
      var b = mk('div', 'lpc-b');
      var sr = mk('span', 'sr');
      sr.textContent = L.typing || '';
      b.appendChild(sr);
      for (var i = 0; i < 3; i += 1) b.appendChild(mk('i', '', { 'aria-hidden': 'true' }));
      typing.appendChild(b);
      log.appendChild(typing);
      scrollEnd();
    }
    function hideTyping() { if (typing && typing.parentNode) typing.parentNode.removeChild(typing); typing = null; }

    /* ---------- Envoi ---------- */
    function history() {
      var out = [];
      state.msgs.forEach(function (m) {
        if (m.r === 'u' && !m.x) out.push({ role: 'user', content: m.t });
        else if (m.r === 'a') out.push({ role: 'assistant', content: JSON.stringify({ reply: m.t, handoff: !!m.h, topic: m.tp || 'autre' }) });
      });
      return out.slice(-23);
    }
    function send(text) {
      text = String(text || '').trim().slice(0, MAX_LEN);
      if (!text || busy || userCount() >= MAX_TURNS) return;
      if (sugg && sugg.parentNode) { sugg.parentNode.removeChild(sugg); sugg = null; }
      var um = { r: 'u', t: text };
      state.msgs.push(um);
      save();
      log.appendChild(bubble(um));
      ta.value = '';
      grow();
      counter();
      busy = true;
      lockIfDone();
      showTyping();
      updateDot();
      publish('lp_chat_message', { turn: userCount() });

      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT);
      fetch(cfg.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify({ messages: history(), page: location.pathname }),
        credentials: 'omit',
        mode: 'cors',
        signal: ctrl ? ctrl.signal : undefined
      })
        .then(function (res) { return res.json().catch(function () { return null; }); })
        .catch(function () { return null; })
        .then(function (data) {
          clearTimeout(timer);
          hideTyping();
          busy = false;
          var m;
          if (data && typeof data.reply === 'string' && data.reply) {
            if (data.error && data.error !== 'turns') um.x = true;
            m = { r: data.error ? 'e' : 'a', t: data.reply, h: !!data.handoff, tp: data.topic || 'autre' };
          } else {
            um.x = true;
            m = { r: 'e', t: cfg.errorText || '', h: true, tp: 'autre' };
          }
          state.msgs.push(m);
          save();
          var old = log.querySelectorAll('.lpc-card');
          for (var i = 0; i < old.length; i += 1) old[i].parentNode.removeChild(old[i]);
          log.appendChild(bubble(m));
          if (m.h) { log.appendChild(card()); publish('lp_chat_handoff', { topic: m.tp }); }
          lockIfDone();
          scrollEnd();
          if (!small() && !ta.disabled) focusInput();
        });
    }

    /* ---------- Vers l'équipe ---------- */
    function lastTopic() {
      for (var i = state.msgs.length - 1; i >= 0; i -= 1) {
        var m = state.msgs[i];
        if (m.r === 'a' && m.tp && m.tp !== 'hors_sujet' && m.tp !== 'autre') return m.tp;
      }
      return 'autre';
    }
    function buildPrefill() {
      var lines = state.msgs.filter(function (m) { return m.r === 'u' || m.r === 'a'; }).map(function (m) {
        return (m.r === 'u' ? L.you : L.bot) + ' : ' + plain(m.t);
      });
      if (!lines.length) return null;
      var body = lines.join('\n');
      while (body.length > 3000 && lines.length > 1) { lines.shift(); body = '[…]\n' + lines.join('\n'); }
      return {
        subject: SUBJECTS[lastTopic()] || OTHER,
        body: '\n\n---\n' + (cfg.transcriptTitle || '') + '\n' + body,
        ts: Date.now()
      };
    }
    function toTeam(source) {
      publish('lp_chat_team', { source: source, turns: userCount() });
      var pre = buildPrefill();
      var here = findForm(document);
      if (here) {
        closePanel(false);
        if (pre) fillForm(here, pre);
        else here.scrollIntoView({ block: 'start' });
        return;
      }
      if (pre && !cfg.design) ss.set(PREFILL, pre);
      var path = String(cfg.contactPath || '/pages/contact').split('#')[0];
      if (!/^\/[^/]/.test(path)) path = '/pages/contact';
      location.href = path + '#contact';
    }

    /* ---------- Ouverture et fermeture ---------- */
    var vv = window.visualViewport;
    var lastFit = '';
    var fullH = 0;
    var raf = 0;
    var watchUntil = 0;
    /* Mobile : le panneau couvre exactement la zone visible (au-dessus du clavier). Clavier ouvert : pied masqué,
       le champ touche le clavier. Rien n'est réécrit si la zone n'a pas bougé. */
    function fit() {
      if (!panel || !isOpen) return;
      if (small() && vv) {
        var h = Math.round(vv.height);
        var top = Math.max(0, Math.round(vv.offsetTop));
        var vh = vv.height * (vv.scale || 1);
        var focused = document.activeElement === ta;
        /* Hauteur de référence prise hors saisie : le clavier est repéré même si la fenêtre entière rétrécit (Android). */
        if (!focused || !fullH) fullH = Math.max(document.documentElement.clientHeight, window.innerHeight, vh);
        var kb = focused && fullH - vh > 120;
        var key = h + ',' + top + ',' + kb;
        if (key === lastFit) return;
        lastFit = key;
        var atEnd = log.scrollHeight - log.scrollTop - log.clientHeight < 48;
        panel.style.height = h + 'px';
        panel.style.top = top + 'px';
        panel.classList.toggle('lpc-kb', kb);
        if (atEnd) scrollEnd();
      } else {
        lastFit = '';
        panel.style.height = '';
        panel.style.top = '';
        panel.classList.remove('lpc-kb');
        scrollEnd();
      }
    }
    /* iOS n'envoie pas toujours l'événement quand il fait glisser la zone visible vers le champ : la zone est relue
       à chaque image pendant l'animation du clavier et tant que le champ a le focus. */
    function watch(ms) {
      if (!isOpen || !small() || !vv) return;
      watchUntil = Math.max(watchUntil, Date.now() + (ms || 0));
      if (raf) return;
      var step = function () {
        raf = 0;
        if (!isOpen) return;
        fit();
        if (Date.now() < watchUntil || document.activeElement === ta) raf = requestAnimationFrame(step);
      };
      raf = requestAnimationFrame(step);
    }
    function onViewport() { fit(); watch(600); }
    /* Page figée derrière le plein écran (technique compatible iOS Safari) ; la position est rendue telle quelle. */
    var pageLock = null;
    function lockPage() {
      if (pageLock) return;
      var b = document.body;
      pageLock = { y: window.pageYOffset || document.documentElement.scrollTop || 0, top: b.style.top };
      b.style.top = -pageLock.y + 'px';
      document.documentElement.classList.add('lpc-lock');
      panel.setAttribute('aria-modal', 'true');
    }
    function unlockPage() {
      if (!pageLock) return;
      var de = document.documentElement;
      var y = pageLock.y;
      de.classList.remove('lpc-lock');
      document.body.style.top = pageLock.top;
      pageLock = null;
      panel.setAttribute('aria-modal', 'false');
      var sb = de.style.scrollBehavior;
      de.style.scrollBehavior = 'auto'; /* le thème défile en douceur : retour instantané ici */
      window.scrollTo(0, y);
      de.style.scrollBehavior = sb;
    }
    /* Rotation ou fenêtre redimensionnée en passant le seuil des 768 px, chat ouvert. */
    function onWindow() {
      if (!isOpen) return;
      if (small()) lockPage(); else unlockPage();
      fit();
      watch(600);
    }
    function focusInput() { try { if (ta && !ta.disabled) ta.focus({ preventScroll: true }); } catch (e) { /* rien */ } }
    function open() {
      if (isOpen) return;
      if (!panel) build();
      opener = document.activeElement;
      isOpen = true;
      panel.hidden = false;
      host.classList.add('is-open');
      launch.setAttribute('aria-expanded', 'true');
      if (small()) lockPage();
      if (vv) { vv.addEventListener('resize', onViewport); vv.addEventListener('scroll', onViewport); }
      addEventListener('resize', onWindow);
      fit();
      watch(600);
      requestAnimationFrame(function () { panel.classList.add('is-in'); });
      updateDot();
      if (small()) { try { panel.querySelector('.lpc-t').focus({ preventScroll: true }); } catch (e) { /* rien */ } } else focusInput();
      scrollEnd();
      publish('lp_chat_open', { turns: userCount() });
    }
    function closePanel(restoreFocus) {
      if (!isOpen) return;
      isOpen = false;
      host.classList.remove('is-open');
      launch.setAttribute('aria-expanded', 'false');
      if (vv) { vv.removeEventListener('resize', onViewport); vv.removeEventListener('scroll', onViewport); }
      removeEventListener('resize', onWindow);
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      watchUntil = 0;
      lastFit = '';
      fullH = 0;
      panel.classList.remove('lpc-kb');
      unlockPage();
      panel.setAttribute('aria-modal', 'false');
      panel.classList.remove('is-in');
      var hide = function () { if (!isOpen) panel.hidden = true; };
      if (reduced()) hide(); else setTimeout(hide, 220);
      updateDot();
      if (restoreFocus) {
        var back = opener && document.contains(opener) && opener !== document.body ? opener : launch;
        try { (launch.offsetParent ? launch : back).focus({ preventScroll: true }); } catch (e) { /* rien */ }
      }
    }
    function focusables() {
      return Array.prototype.filter.call(panel.querySelectorAll('button, a[href], textarea, [tabindex]:not([tabindex="-1"])'), function (n) {
        return !n.disabled && n.getClientRects().length;
      });
    }
    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); closePanel(true); return; }
      if (e.key !== 'Tab' || !small()) return; // piège du focus seulement en plein écran
      var f = focusables();
      if (!f.length) return;
      var first = f[0];
      var lastEl = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); } else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
    }

    launch.addEventListener('click', function () { if (isOpen) closePanel(true); else open(); });
    launch.hidden = false;
    if (!reduced()) launch.classList.add('is-in');
    updateDot();

    /* Éditeur de thème : aperçu du panneau quand la section est sélectionnée. */
    if (cfg.design) {
      document.addEventListener('shopify:section:select', function (e) { if (e.detail && e.detail.sectionId === cfg.id) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.detail && e.detail.sectionId === cfg.id) closePanel(false); });
    }
  }

  function start() {
    applyPendingPrefill();
    var hosts = document.querySelectorAll('[data-lp-chat]');
    for (var i = 0; i < hosts.length; i += 1) init(hosts[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', function (e) {
    var h = e.target && e.target.querySelector ? e.target.querySelector('[data-lp-chat]') : null;
    if (h) init(h);
  });
})();
